import { EnvironmentType } from "@app/models/env";

export const environment: EnvironmentType = EnvironmentType.production;
